module.exports = __webpack_public_path__ + "static/media/Calendar.f6c89501.svg";